export default "__VITE_ASSET__B7PuhS2i__"